import Axios from 'axios';
import { useContext, useEffect, useReducer, useRef } from 'react';
import { systemCode, xs_languageCode } from '..';
import { dataFetchReducer } from './utils/dataFetchReducer';
import { getConfiguration } from './utils/configuration';
import { BetslipContext } from './betslip/BetslipConf';

function buildJsonRequest(matchesData, isLive) {
    let jsonRequest = {events:[]};
    Object.values(matchesData).forEach(function(m) {
        jsonRequest.events.push({pal: m.pal, avv: m.avv, idAggregata: m.idAggregata, isLive: isLive});
    });

    return encodeURI(JSON.stringify(jsonRequest));
}

export function useFetchFavouriteMatchesData(matchesData, isLive, shouldExecute) {
    const ctxs = useRef({}).current;
    ctxs.betslipContext =  useContext(BetslipContext);
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }

        let didCancel = false;
        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getEventsBatch;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            jsonRequest: buildJsonRequest(matchesData, isLive)
        }
        fetchData(url, params, function(response) {
            const payloadData = response;
            dispatch({ type: 'FETCH_SUCCESS', payload: payloadData });
        });

        let interval;
        
        const intervalMillis = getConfiguration()?.lpo ?? 10000;
        interval = setInterval(() => {
            if(!ctxs?.betslipContext?.betInProgress) {
                const params = {
                    systemCode,
                    lingua: xs_languageCode,
                    hash: '',
                    jsonRequest: buildJsonRequest(matchesData, isLive)
                }
                fetchData(url, params, function(response) {
                    const payloadData = response;
                    dispatch({ type: 'FETCH_SUCCESS', payload: payloadData });
                });
            }
        }, intervalMillis);
        
        return () => {
            didCancel = true;
            clearInterval(interval);
        };
    }, [matchesData, isLive, shouldExecute]);

    return [state, dispatch];
}
